<template>
     <div class="limiter">
    <div class="container-login">
      <div class="wrap-login p-l-55 p-r-55 p-t-65 p-b-54">
        <div class="login-form validate-form">
          <img src="@/assets//img/logo-grande.jpg" alt="Thumbnail" class="img-logo flex-c-m"/>
          <section>
            <div id="notify" ref="notify" class="login-form-title p-b-20"></div>
            <div>
                <div style="text-align: center; margin-bottom: 20px; margin-top: 20px;">
                  <label>Redefina sua senha</label>
                </div>
                <div class="input-container">
                  <i class="fa fa-key icon"></i>
                  <input type="password" v-model="newPassword" v-on:keydown.enter="$refs.inputCnfPassword.focus()" id="inputNewPassword" ref="inputNewPassword" placeholder="Nova senha" class="input-field" />
                </div>
                <password v-model="newPassword" :strength-meter-only="true" @score="setPasswordScore" />
                <div class="input-container">
                  <i class="fa fa-key icon"></i>
                  <input type="password" v-model="cnfPassword" v-on:keydown.enter="$refs.btnRedefine.focus()" id="inputPassword" ref="inputCnfPassword" placeholder="Confirmar senha" class="input-field" />
                </div>
                <button class="btn btn-primary btn-padding" ref="btnRedefine" v-on:click="this.resetPassword" v-if="!this.loading">
                  Redefinir
                </button>
                <button class="btn btn-primary btn-padding" v-else disabled>
                  <b-spinner small type="grow"></b-spinner>
                  Redefinindo
                </button>
                <br />
                <span class="login-form-title p-b-30"></span>
            </div>
          </section>
        </div>
      </div>
      <div class="bgImage"></div>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/login.css">
</style>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
  .btn-padding{
    padding: .375rem .75rem;
  }
</style>

<script>
import axios from 'axios';
import Password from 'vue-password-strength-meter';
import config from '../helpers/generalConfig';

export default {
  components: { Password },
  data() {
    return {
      token: this.$route.params.token,
      newPassword: '',
      cnfPassword: '',
      loading: false,
      passwordScore: 0,
    };
  },
  methods: {
    resetPassword() {
      if (!this.newPassword) {
        this.$bvToast.toast('Informe uma nova senha.', {
          title: 'Senha inválida',
          variant: 'danger',
          solid: true
        });
        return;
      }
      if (!this.cnfPassword) {
        this.$bvToast.toast('Confirme a nova senha.', {
          title: 'Senha inválida',
          variant: 'danger',
          solid: true
        });
        return;
      }
      if (this.cnfPassword !== this.newPassword) {
        this.$bvToast.toast('A nova senha e a confirmação divergem.', {
            title: 'Senha inválida',
            variant: 'danger',
            solid: true
        });
        return;
      }
      axios.post(
        `${config.jsonServer}/user/resetPassword`,
        {
          token: this.token,
          candidata: this.newPassword
        }
      ).then(() => {
        this.$router.push({ name: 'login', params: {
          message: "Senha alterada com sucesso",
          body: {
            title: "Conecte-se novamente",
            variant: "success",
            solid: true,
          }
        }});
      }).catch((err) => {
        if(err.response) {
          this.$bvToast.toast(err.response.data.message, {
            title: 'Erro ao alterar senha',
            variant: 'danger',
            solid: true
          });
          this.password = '';
          this.newPassword = '';
        }else {
          this.$router.push({ name: 'login', params: {
            message: "Tente novamente",
            body: {
              title: "Sem resposta do servidor",
              variant: "danger",
              solid: true,
            }
          }});
        }
      });
    },
    clearFields() {
      this.password = '';
      this.rePassword = '';
    },
    setPasswordScore(score) {
      this.passwordScore = score;
    },
  }
};
</script>